export default class Room {
    id: number;
    code: string;
    name: string;
    capacity: number;
    location: string;
    number: number;
    notes: string;

    get display() {
        return this.name;
    }

    constructor(data: Partial<Room>) {
        Object.assign(this, data);
    }
}
